import { render } from "./PlacedBuilding.vue?vue&type=template&id=86cea448&scoped=true"
import script from "./PlacedBuilding.vue?vue&type=script&lang=js"
export * from "./PlacedBuilding.vue?vue&type=script&lang=js"

import "./PlacedBuilding.vue?vue&type=style&index=0&id=86cea448&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-86cea448"]])

export default __exports__